var map = {
	"./flag-ae.svg": 44626,
	"./flag-at.svg": 35093,
	"./flag-au.svg": 71531,
	"./flag-be.svg": 62856,
	"./flag-ch.svg": 96256,
	"./flag-cl.svg": 85798,
	"./flag-cn.svg": 10142,
	"./flag-co.svg": 21152,
	"./flag-cr.svg": 34200,
	"./flag-cz.svg": 46950,
	"./flag-de.svg": 20529,
	"./flag-dk.svg": 35444,
	"./flag-es.svg": 17101,
	"./flag-fi.svg": 11225,
	"./flag-fr.svg": 27385,
	"./flag-gb.svg": 21611,
	"./flag-hk.svg": 11451,
	"./flag-ie.svg": 21382,
	"./flag-in.svg": 77487,
	"./flag-it.svg": 94399,
	"./flag-jp.svg": 60998,
	"./flag-kr.svg": 10710,
	"./flag-mx.svg": 35371,
	"./flag-nl.svg": 95438,
	"./flag-no.svg": 72561,
	"./flag-pl.svg": 7807,
	"./flag-pr.svg": 11385,
	"./flag-pt.svg": 22708,
	"./flag-sa.svg": 17959,
	"./flag-se.svg": 6932,
	"./flag-sg.svg": 74763,
	"./flag-si.svg": 62658,
	"./flag-sk.svg": 74446,
	"./flag-tw.svg": 72867,
	"./flag-us.svg": 27895,
	"./flag-vn.svg": 457,
	"./flag-za.svg": 16154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11551;